/* eslint-disable import/prefer-default-export */

export const selectJwtToken = (state) => state.auth.jwtToken;
export const selectUserType = (state) => state.auth.userType;
export const selectAthurised = (state) => state.auth.authorized;
export const selectUserInfo = (state) => state.auth.userInfo;
